function EditAddresses() {
    return (
        <div>
            <h2>Edit Addresses</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default EditAddresses;